<template>
  <modal
    ref="modal"
    title="Editar dados"
    :showModal="hasModalOwnerEdit"
    @close="closeModalEdit"
  >
    <template v-slot:body>
      <ValidationObserver
        tag="div"
        class="body"
        ref="form"
        v-slot="{ passes, pristine }"
      >
        <form @input="toggleButtonState(pristine)" @submit.prevent="passes(submitCompanyFormData)">
          <div class="wrapper">
            <div class="section">
              <div class="column">
                <input-field
                  placeholder="CPF"
                  mask="###.###.###-##"
                  rules="required"
                  v-model="companyData.ownerTaxpayerId"
                />
              </div>

              <div class="two-column">
                <input-field
                  placeholder="Nome completo"
                  rules="required"
                  v-model="companyData.ownerCompletedName"
                />

                <input-field
                  class="right"
                  placeholder="Data de nascimento"
                  mask="##/##/####"
                  rules="required"
                  v-model="companyData.ownerBirthDate"
                />
              </div>

              <div class="two-column">
                <input-field
                  placeholder="E-mail"
                  rules="required|mail"
                  v-model="companyData.ownerEmail"
                />

                <input-field
                  class="right"
                  placeholder="Telefone"
                  name="phone"
                  rules="required|phone"
                  :mask="['(##) ####-####', '(##) #####-####']"
                  v-model="companyData.ownerPhoneNumber"
                />
              </div>
            </div>

            <div class="button-container">
              <button-component
                scale="normal"
                size="large"
                v-ripple="$theme.secondColorDarkTransparent"
                styles="ghost"
                type="button"
                :isDisabled="hasRequest"
                text="Fechar"
                @click.native="closeModalEdit"
              />

              <button-component
                class="right"
                scale="normal"
                size="large"
                v-ripple="$theme.whiteColorTransparent"
                styles="primary"
                :isDisabled="hasRequest || isButtonDisable"
                :hasLoader="hasRequest"
                text="Alterar e salvar"
              />
            </div>
          </div>
        </form>
      </ValidationObserver>
    </template>
  </modal>
</template>

<script>
  import { ValidationObserver } from 'vee-validate';
  import { mapState } from 'vuex';
  import Modal from '@/components/Modal/Base';
  import Button from '@/components/Base/Button';
  import InputField from '@/components/Base/InputField';

  export default {
    name: 'EditOwnerModal',

    data() {
      return {
        hasRequest: false,
        isButtonDisable: true,
        companyData: {
          ownerCompletedName: '',
          ownerFirstData: '',
          ownerLastData: '',
          ownerTaxpayerId: '',
          ownerBirthDate: '',
          ownerEmail: '',
          ownerPhoneNumber: '',
          businessAddressLine: '',
          businessAddressNumber: '',
          businessAddressComplement: '',
          businessAddressNeighborhood: '',
          businessAddressCity: '',
          businessAddressState: '',
          businessAddressPostalCode: '',
          ownerAddressLine: '',
          ownerAddressNumber: '',
          ownerAddressComplement: '',
          ownerAddressNeighborhood: '',
          ownerAddressCity: '',
          ownerAddressState: '',
          ownerAddressPostalCode: '',
        },
      };
    },

    components: {
      ValidationObserver,
      'button-component': Button,
      'input-field': InputField,
      'modal': Modal
    },

    computed: {
      ...mapState({
        hasModalOwnerEdit: state => state.hasModalOwnerEdit,
        sellerData: state => state.sellerData,
      })
    },

    watch: {
      sellerData() {
        this.setDefaultCompanyValues();
      },

      hasModalOwnerEdit() {
        this.setDefaultCompanyValues();
      }
    },

    mounted() {
      this.setDefaultCompanyValues();
    },

    methods: {
      async submitCompanyFormData() {
        this.hasRequest = true;

        let formData = JSON.stringify({
          owner_first_name: this.$service.splitFirstName(this.companyData.ownerCompletedName),
          owner_last_name: this.$service.splitLastName(this.companyData.ownerCompletedName),
          owner_phone_number: this.$service.removeCharacter(this.companyData.ownerPhoneNumber),
          owner_taxpayer_id: this.$service.removeCharacter(this.companyData.ownerTaxpayerId),
          owner_birthdate: this.$service.dateFormat(this.companyData.ownerBirthDate, 'DD/MM/YYYY', 'YYYY-MM-DD'),
          owner_email: this.companyData.ownerEmail,
          business_address_line1: this.companyData.businessAddressLine,
          business_address_line2: this.companyData.businessAddressNumber,
          business_address_line3: this.companyData.businessAddressComplement,
          business_address_neighborhood: this.companyData.businessAddressNeighborhood,
          business_address_city: this.companyData.businessAddressCity,
          business_address_state: this.companyData.businessAddressState,
          business_address_postal_code: this.$service.removeCharacter(this.companyData.businessAddressPostalCode),
          owner_address_line1: this.companyData.ownerAddressLine,
          owner_address_line2: this.companyData.ownerAddressNumber,
          owner_address_line3: this.companyData.ownerAddressComplement,
          owner_address_neighborhood: this.companyData.ownerAddressNeighborhood,
          owner_address_city: this.companyData.ownerAddressCity,
          owner_address_state: this.companyData.ownerAddressState,
          owner_address_postal_code: this.$service.removeCharacter(this.companyData.ownerAddressPostalCode),
        });

        await this.$store.dispatch('putCompanySeller', { formData })
          .then(() => {
            this.snackbarNotification('Dados editados com sucesso', '#08B978');
          })
          .catch(() => {
            this.snackbarNotification('Erro ao editar os dados cadastrais', '#FF5A5A');
          });

        this.closeModalEdit();

        await this.$store.dispatch('getSellerId')
          .catch(() => {
            this.snackbarNotification('Erro ao atualizar os dados', '#FF5A5A');
          });

        this.isButtonDisable = true;
        this.hasRequest = false;
      },

      setDefaultCompanyValues() {
        this.companyData.ownerCompletedName = this.sellerData.owner_first_name + ' ' + this.sellerData.owner_last_name;
        this.companyData.ownerTaxpayerId = this.sellerData.owner_taxpayer_id;
        this.companyData.ownerBirthDate = this.$service.dateFormat(this.sellerData.owner_birthdate, 'YYYY-MM-DD', 'DD/MM/YYYY');
        this.companyData.ownerEmail = this.sellerData.owner_email;
        this.companyData.ownerPhoneNumber = this.sellerData.owner_phone_number;

        this.companyData.ownerAddressLine = this.sellerData.owner_address_line1;
        this.companyData.ownerAddressNumber = this.sellerData.owner_address_line2;
        this.companyData.ownerAddressComplement = this.sellerData.owner_address_line3;
        this.companyData.ownerAddressNeighborhood = this.sellerData.owner_address_neighborhood;
        this.companyData.ownerAddressCity = this.sellerData.owner_address_city;
        this.companyData.ownerAddressState = this.sellerData.owner_address_state;
        this.companyData.ownerAddressPostalCode = this.sellerData.owner_address_postal_code;

        this.companyData.businessAddressLine = this.sellerData.business_address_line1;
        this.companyData.businessAddressNumber = this.sellerData.business_address_line2;
        this.companyData.businessAddressComplement = this.sellerData.business_address_line3;
        this.companyData.businessAddressNeighborhood = this.sellerData.business_address_neighborhood;
        this.companyData.businessAddressCity = this.sellerData.business_address_city;
        this.companyData.businessAddressState = this.sellerData.business_address_state;
        this.companyData.businessAddressPostalCode = this.sellerData.business_address_postal_code;
      },

      closeModalEdit() {
        this.$store.commit('closeModalEdit');
      },

      toggleButtonState(pristine) {
        this.isButtonDisable = pristine;

        if (this.hasRequest) {
          this.isButtonDisable = true;
        }
      },

      snackbarNotification(text, color) {
        this.$emit('snackbarNotification', text, color);
      }
    }
  };
</script>

<style lang="scss" scoped>
  .modal {
    .body {
      .wrapper {
        margin-top: 1.5rem;
        .section {
          .two-column {
            display: flex;

            .right {
              margin-left: 1rem;
              max-width: 225px;
            }
          }

          .column {
            max-width: 305px;
          }
        }
      }
    }

    .button-container {
      display: flex;
      justify-content: flex-end;

      .right {
        margin-left: 1rem;
        min-width: 156px;
      }
    }
  }

  @media (max-width: 767px) {
    .modal {
      h2 {
        font-size: 16px;
      }
    }
  }

  @media (max-width: 520px) {
    .modal {
      .body {
        .wrapper {
          overflow-y: scroll;
          max-height: 72vh;
          margin-bottom: 4rem;

          &::-webkit-scrollbar {
            display: none;
          }

          .section {
            .two-column {
              flex-direction: column;

              .right {
                margin-left: 0;
                max-width: initial;
              }
            }

            .column {
              width: 100%;
              max-width: unset;
            }
          }

          .button-container {
            justify-content: center;
          }
        }
      }
    }
  }
</style>